import { UseInfiniteQueryResult } from "@tanstack/react-query";

import { PaginatedConversationRecordWithMessages } from "~/api/generated/multiagent";
import { useApiClient, useInfintieApiQuery } from "~/api/use-api";
import { CONVERSATION_KEY } from "~/types/query-keys";
import { useTenantId } from "~/util/use-active-tenant-id";

export const useInfiniteConversation = ({
  conversationId,
  limit,
  enabled = true,
}: {
  conversationId: string;
  limit: number;
  enabled?: boolean;
}): UseInfiniteQueryResult<
  PaginatedConversationRecordWithMessages,
  unknown
> => {
  const { disease } = useTenantId();
  const apiClient = useApiClient(
    "multiagent",
    {},
    CONVERSATION_KEY(disease, conversationId),
  );

  return useInfintieApiQuery(
    "multiagent",
    async ({ pageParam = undefined }) =>
      apiClient.getConversationWithId({
        conversationId: conversationId,
        cursor: pageParam,
        limit,
      }),
    CONVERSATION_KEY(disease, conversationId),
    (lastPage) => lastPage.pagination?.cursor,
    { refetchOnWindowFocus: false, enabled },
  );
};
